import { render, staticRenderFns } from "./certifyStandardDetail.vue?vue&type=template&id=2be9ea67"
import script from "./certifyStandardDetail.vue?vue&type=script&lang=js"
export * from "./certifyStandardDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports